import Api, {
  baseURL,
  requestOptionsGET,
  requestOptionsPOST,
  requestOptionsDELETE,
  requestOptionsPUTWithBody,
  requestOptionsDELETEWithBody
} from '../api';
import newFetch from '../utils/newFetch';

const state = {
  boarding: [],
  unallocatedCargos: []
};

const getters = {
  getBoarding: (state) => state.boarding,
  getUnallocatedCargos: (state) => state.unallocatedCargos
};

const mutations = {
  setBoardingByid(state, payload) {
    state.boarding = payload;
  },
  setUnallocatedCargosByid(state, payload) {
    state.unallocatedCargos = payload;
  },
  setTranshipmentByCityid(state, payload) {
    state.transhipmentByCity = payload;
  }
};

const actions = {
  getAllBoarding(context, id) {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.getBoardingsManualBoarding + id, requestOptionsGET(localStorage.getItem('accessToken')))
        .then(({ data }) => {
          context.commit('setBoardingByid', data);
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },

  getAllUnallocatedCargos(context, processId) {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.getUnallocatedCargos + processId, requestOptionsGET(localStorage.getItem('accessToken')))
        .then(({ data }) => {
          context.commit('setUnallocatedCargosByid', data);
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  createNewBoarding(_, model) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.createBoardingManualBoarding + model.processId,
        requestOptionsPOST(localStorage.getItem('accessToken'), {
          directDelivererId: model.directDelivererId,
          freightPrice: model.freightPrice,
          totalMileage: model.totalMileage
        })
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  editBoarding(_, model) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.updateBoardingManualBoarding + model.id,
        requestOptionsPUTWithBody(localStorage.getItem('accessToken'), {
          directDelivererId: model.directDelivererId,
          freightPrice: model.freightPrice,
          totalMileage: model.totalMileage
        })
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  createGroupedBoarding(_, processId) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.createGroupedBoarding + processId,
        requestOptionsPOST(localStorage.getItem('accessToken'), {})
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  getCargosByBoardingId(_, id) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.getCargosByBoardingIdManualBoarding + id,
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then(({ data }) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  allocateCargo(_, params) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.allocateCargosManualBoarding + params.id,
        requestOptionsPOST(localStorage.getItem('accessToken'), { cargosIds: params.cargosIds })
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  deallocateCargo(_, params) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.deallocateCargosManualBoarding + params.id,
        requestOptionsPOST(localStorage.getItem('accessToken'), { cargosIds: params.cargosIds })
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  deleteBoarding(_, id) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.deleteBoardingManualBoarding + id,
        requestOptionsDELETE(localStorage.getItem('accessToken'))
      )
        .then((data) => {
          resolve(data);
          return data;
        })
        .catch((err) => {
          reject(err);
          return err;
        });
    });
  },
  deleteMultipleBoardings(_, ids) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.deleteMultipleBoardingsManualBoarding,
        requestOptionsDELETEWithBody(localStorage.getItem('accessToken'), { boardingsIds: ids })
      )
        .then((data) => {
          resolve(data);
          return data;
        })
        .catch((err) => {
          reject(err);
          return err;
        });
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
